import {
	GET_RECOMMENDED_ITEMS,
	GET_RECOMMENDED_ITEMS_SUCCESS,
	GET_RECOMMENDED_ITEMS_FAIL,
	CLEAR_RECOMMENDED_ITEMS,
} from "./actionTypes";

const initialState = {
	items: {},
	itemTagsByItem: {},
	loading: false,
	error: null,
};

const recommendedItemsReducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_RECOMMENDED_ITEMS:
			return {
				...state,
				loading: true,
				error: null,
			};

		case GET_RECOMMENDED_ITEMS_SUCCESS:
			return {
				...state,
				items: action.payload.items,
				itemTagsByItem: action.payload.itemTagsByItem,
				loading: false,
				error: null,
			};

		case GET_RECOMMENDED_ITEMS_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};

		case CLEAR_RECOMMENDED_ITEMS:
			return initialState;

		default:
			return state;
	}
};

export default recommendedItemsReducer;

